module.exports = __webpack_public_path__ + "img/save.ecca0598.svg";